import { __rest } from 'tslib';
import React from 'react';
import { styled } from '@teko/ui';
import { LogoLoading } from '../Loading/LogoLoading.es.js';

const Wrapper = styled.div `
  position: relative;
  border-radius: 0.5rem;
  background: #fff;
  height: ${(props) => props.height + 'px'};
  user-select: none;
`;
const StyledLogoLoading = styled(LogoLoading) `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;
const PreLoad = (_a) => {
    var { height, isLoading, hideLogo = false, logo } = _a, props = __rest(_a, ["height", "isLoading", "hideLogo", "logo"]);
    if (!isLoading)
        return null;
    return (React.createElement(Wrapper, Object.assign({}, props, { height: height }), !hideLogo && React.createElement(StyledLogoLoading, { logo: logo })));
};

export { PreLoad };
